import { axiosGet, axiosPost } from "../../RestApis/restApiUseAxios";
import axiosInstance from "../axios/axios";

const leadList = async (body) => {
  try {
    const response = await axiosInstance.post("/Leads/getLeads", body); // replace with your endpoint
    //console.log("leadList--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching leadList:", error);
  }
};
const addLead = async (userId, companyId, body) => {
  try {
    debugger;
    const response = await axiosInstance.post(
      `/Leads/addLead/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addLead--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLead:", error);
  }
};
const addLeadExternally = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Leads/addLeadExternally/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadExternally--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLeadExternally:", error);
  }
};
const addLeadEntity = async (userId, companyId, body) => {
  try {
    //console.log("addLeadEntity===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/LeadEntity/addLeadEntity/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadEntity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLeadEntity:", error);
  }
};
const addLeadEntityConsumptionHeadersByLeadId = async (
  leadId,
  userId,
  companyId,
  body
) => {
  try {
    // console.log(
    //   "addLeadEntityConsumptionHeadersByLeadId===>",
    //   leadId,
    //   userId,
    //   companyId,
    //   body
    // );
    const response = await axiosInstance.post(
      `LeadEntity/addLeadEntityConsumptionHeadersByLeadId/${companyId}/${userId}/${leadId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadEntityConsumptionHeadersByLeadId--->", response?.data);
    return response;
  } catch (error) {
    console.error(
      "Error fetching addLeadEntityConsumptionHeadersByLeadId:",
      error
    );
  }
};
const updateLeadEntity = async (userId, companyId, body) => {
  try {
    //console.log("updateLeadEntity===>", userId, companyId, body);
    const response = await axiosInstance.post(
      `/LeadEntity/updateLeadEntity/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("updateLeadEntity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching updateLeadEntity:", error);
  }
};
const getleadById = async (body) => {
  //console.log("getleadById===>", body);
  try {
    const response = await axiosInstance.post(`/Leads/getLeadById`, body); // replace with your endpoint
    //console.log("getleadById--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getleadById:", error);
  }
};

const updatelead = async (userId, companyId, body) => {
  // console.log("updatelead ===>", userId, companyId, body);
  // console.log("updatelead body===>", JSON.stringify(body));
  try {
    const response = await axiosInstance.post(
      `/Leads/updateLead/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("updatelead--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching updatelead:", error);
  }
};
const updateleadStatus = async (userId, companyId, body) => {
  //console.log("updateleadStatus===>", userId, companyId, body);
  try {
    const response = await axiosInstance.post(
      `/Leads/updateLeadStatus/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("updateleadStatus--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching updateleadStatus:", error);
  }
};
const deletelead = async (leadId) => {
  //console.log("Deletelead===>", leadId);
  try {
    const response = await axiosInstance.delete(`/lead/Delete/${leadId}`); // replace with your endpoint
    //console.log("Deletelead--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching Deletelead:", error);
  }
};

const leadStatus = async (statusTypeId) => {
  //console.log("leadStatus===>", statusTypeId);
  try {
    const response = await axiosInstance.get(
      `/Status/getAllStatus/${statusTypeId}`
    ); // replace with your endpoint
    //console.log("leadStatus--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching leadStatus:", error);
  }
};

const getLeadEntityAnnualConsumptionByLeadId = async (leadId) => {
  //console.log("getLeadEntityAnnualConsumptionByLeadId===>", leadId);
  try {
    const response = await axiosInstance.get(
      `/LeadEntity/getLeadEntityAnnualConsumptionByLeadId/${leadId}`
    ); // replace with your endpoint
    //console.log("getLeadEntityAnnualConsumptionByLeadId--->", response?.data);
    return response;
  } catch (error) {
    console.error(
      "Error fetching getLeadEntityAnnualConsumptionByLeadId:",
      error
    );
  }
};
const getEntityConsumptionHeaderByLeadId = async (leadId) => {
  try {
    const response = await axiosInstance.get(
      `/LeadEntity/getEntityConsumptionHeaderByLeadId/${leadId}`
    ); // replace with your endpoint
    //console.log("getEntityConsumptionHeaderByLeadId--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getEntityConsumptionHeaderByLeadId:", error);
  }
};
const utilityCompany = async (body) => {
  try {
    const response = await axiosInstance.post(
      `/UtilityCompany/getAllUtilityCompany`,
      body
    ); // replace with your endpoint
    //console.log("utilityCompany--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching utilityCompany:", error);
  }
};
const addLeadEntityBulkUpload = async (userId, companyId, leadId, body) => {
  try {
    const response = await axiosInstance.post(
      `/LeadEntity/addLeadEntityBulkUpload/${userId}/${companyId}/${leadId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadEntityBulkUpload--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLeadEntityBulkUpload:", error);
  }
};
const leadSource = async () => {
  try {
    const response = await axiosInstance.get(`/LeadSource/getAllLeadSource`); // replace with your endpoint
    //console.log("leadSource--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching leadSource:", error);
  }
};
const currentSupplier = async (id) => {
  try {
    const response = await axiosInstance.get(`/Supplier/getAllSuppliers/${id}`); // replace with your endpoint
    //console.log("currentSupplier--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching currentSupplier:", error);
  }
};
const getSaleUser = async () => {
  try {
    const response = await axiosInstance.get(`/User/getSalesUsers`); // replace with your endpoint
    //console.log("getSaleUser--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getSaleUser:", error);
  }
};

const getAllStatus = async (statusTypeId) => {
  try {
    const response = await axiosInstance.get(
      `/Status/getAllLeadStatus/${statusTypeId}`
    ); // replace with your endpoint
    //console.log("getAllStatus--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getAllStatus:", error);
  }
};

const getTaxStatus = async () => {
  try {
    const response = await axiosInstance.get(`/Category/getAllTaxTypes`); // replace with your endpoint
    //console.log("getTaxStatus--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getTaxStatus:", error);
  }
};
const getCommodity = async () => {
  try {
    const response = await axiosInstance.get(`/Category/getAllCommodityTypes`); // replace with your endpoint
    //console.log("getCommodity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getCommodity:", error);
  }
};
const getcustomer = async () => {
  try {
    const response = await axiosInstance.get(`/Customer/getAllCustomers/0`); // replace with your endpoint
    //console.log("getcustomer--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getcustomer:", error);
  }
};
const getLeadActivity = async (leadId) => {
  try {
    const response = await axiosInstance.get(
      `/LeadLog/getAllLeadLog/${leadId}`
    ); // replace with your endpoint
    //console.log("getLeadActivity--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getLeadActivity:", error);
  }
};
const getLeadEntities = async (leadId) => {
  try {
    const response = await axiosInstance.get(
      `/LeadEntity/getAllLeadEntities/${leadId}`
    ); // replace with your endpoint
    //console.log("getLeadEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getLeadEntities:", error);
  }
};
const getLeadAnnualEntities = async (leadId, ConsumptionId) => {
  try {
    const response = await axiosInstance.get(
      `/LeadEntity/getLeadEntityConsumptionAndHeaderByEntityId/${leadId}/${ConsumptionId}`
    ); // replace with your endpoint
    //console.log("getLeadAnnualEntities--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getLeadAnnualEntities:", error);
  }
};
const addLeadEntityAnnualConsumptionByLeadId = async (
  userId,
  companyId,
  leadId,
  body
) => {
  try {
    const response = await axiosInstance.post(
      `/LeadEntity/addLeadEntityAnnualConsumptionByLeadId/${userId}/${companyId}/${leadId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadEntityAnnualConsumptionByLeadId--->", response?.data);
    return response;
  } catch (error) {
    console.error(
      "Error fetching addLeadEntityAnnualConsumptionByLeadId:",
      error
    );
  }
};
const updateLeadEntityAnnualConsumptionByLeadId = async (
  userId,
  companyId,
  leadId,
  body
) => {
  try {
    const response = await axiosInstance.post(
      `/LeadEntity/updateLeadEntityAnnualConsumptionByLeadId/${userId}/${companyId}/${leadId}`,
      body
    ); // replace with your endpoint
    // console.log(
    //   "updateLeadEntityAnnualConsumptionByLeadId--->",
    //   response?.data
    // );
    return response;
  } catch (error) {
    console.error(
      "Error fetching updateLeadEntityAnnualConsumptionByLeadId:",
      error
    );
  }
};

const addLeadOwner = async (leadOwnerId, userId, companyId, body) => {
  try {
    //console.log("addLeadOwner===>", body, leadOwnerId, userId, companyId);
    const response = await axiosInstance.post(
      `/LeadOwner/addLeadOwner/${leadOwnerId}/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadOwner--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLeadOwner:", error);
  }
};
const validateEntityInfo = async (userId, companyId, body) => {
  try {
    //console.log("validateEntityInfo===>", body, leadOwnerId, userId, companyId);
    const response = await axiosInstance.post(
      `/EntityValidation/validateEntityInfo/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("validateEntityInfo--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching validateEntityInfo:", error);
  }
};
const addLeadLoeFile = async (userId, companyId, body) => {
  try {
    //console.log("addLeadLoeFile===>", body, leadOwnerId, userId, companyId);
    const response = await axiosInstance.post(
      `/LeadLoeFile/addLeadLoeFile/${userId}/${companyId}`,
      body
    ); // replace with your endpoint
    //console.log("addLeadLoeFile--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching addLeadLoeFile:", error);
  }
};
const stateDropdown = async () => {
  try {
    //console.log("addLeadOwner===>", body, leadOwnerId, userId, companyId);
    const response = await axiosInstance.get(`/state/getAllStates`); // replace with your endpoint
    //console.log("addLeadOwner--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching stateDropdown:", error);
  }
};
const deleteEntity = async (leadId, entityInfoId) => {
  try {
    const response = await axiosInstance.get(
      `/LeadEntity/deleteLeadEntity/${leadId}/${entityInfoId}`
    );
    console.log("deleteEntity===>", response?.data?.payload);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const getLeadLoeFiles = async (leadId, userId, companyId) => {
  try {
    debugger;
    //console.log("getLeadLoeFiles===>", body, leadOwnerId, userId, companyId);
    const response = await axiosInstance.get(
      `/LeadLoeFile/getLeadLoeFiles/${userId}/${companyId}/${leadId}`
    ); // replace with your endpoint
    //console.log("getLeadLoeFiles--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching getLeadLoeFiles:", error);
  }
};
const addLeadLog = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/LeadLog/addLeadLog/${userId}/${companyId}`,
      body
    );
    console.log("addLeadLog--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};
const updateLeadCustomer = async (userId, companyId, leadId, customerId) => {
  try {
    const response = await axiosInstance.post(
      `/Leads/updateLeadCustomer/${userId}/${companyId}/${leadId}/${customerId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateLeadCustomer:", error);
  }
};
const updateSelectedLoe = async (userId, companyId, leadId, loeId) => {
  try {
    const response = await axiosInstance.post(
      `/LeadLoeFile/updateSelectedLeadLoe/${userId}/${companyId}/${leadId}/${loeId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateSelectedLoe:", error);
  }
};
const truncateLeadEntityLog = async () => {
  try {
    const response = await axiosPost(`/lead/truncate-lead-entity-log`);
    return response;
  } catch (error) {
    console.error("Error fetching truncateLeadEntityLog:", error);
  }
};
const getLeadBulkEntityList = async (leadId, branchId, companyId) => {
  try {
    const response = await axiosGet(`/lead/bulk-entity-list`, {
      LeadId: leadId,
      BranchId: branchId,
      CompanyId: companyId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching getLeadBulkEntityList:", error);
  }
};
const importLeadBulkEntityData = async (body) => {
  try {
    const response = await axiosPost(`/lead/import-bulk-entity-data`, {
      CompanyId: body?.companyId,
      CustomerId: body?.customerId,
      BranchId: body?.branchId,
      UserId: body?.userId,
      LeadBulkEntityList: body?.leadBulkEntityList,
      LeadId: body?.leadId,
      MonthName1: body?.monthName1,
      MonthName2: body?.monthName2,
      MonthName3: body?.monthName3,
      MonthName4: body?.monthName4,
      MonthName5: body?.monthName5,
      MonthName6: body?.monthName6,
      MonthName7: body?.monthName7,
      MonthName8: body?.monthName8,
      MonthName9: body?.monthName9,
      MonthName10: body?.monthName10,
      MonthName11: body?.monthName11,
      MonthName12: body?.monthName12,
    });
    return response;
  } catch (error) {
    console.error("Error fetching importLeadBulkEntityData:", error);
  }
};
const validateBulkLeadEntityInfo = async (body) => {
  try {
    const response = await axiosPost(`/lead/validate-bulk-lead-entity-info`, {
      LeadBulkEntityValidationLst: body?.leadBulkEntityValidationLst,
      LeadId: body?.leadId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching validateBulkLeadEntityInfo:", error);
  }
};
const processLeadBulkEntity = async (body) => {
  try {
    const response = await axiosPost(`/lead/process-bulk-lead-entity-info`, {
      LeadBulkEntityList: body?.leadBulkEntityList,
      BranchId: body?.branchId,
      CompanyId: body?.companyId,
      LeadId: body?.leadId,
      IsAnnualConsumption: body?.isAnnualConsumption,
      //ProductId: body?.productId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching processLeadBulkEntity:", error);
  }
};
const getCategoryDropdownById = async (categoryId) => {
  try {
    const response = await axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getCategoryDropdownById:", error);
  }
};
export const LeadService = {
  leadList,
  leadStatus,
  utilityCompany,
  addLead,
  leadSource,
  currentSupplier,
  getSaleUser,
  addLeadOwner,
  getLeadActivity,
  getleadById,
  getLeadEntities,
  updatelead,
  getTaxStatus,
  getCommodity,
  addLeadEntity,
  updateLeadEntity,
  getLeadAnnualEntities,
  getcustomer,
  getAllStatus,
  updateleadStatus,
  addLeadEntityAnnualConsumptionByLeadId,
  addLeadEntityBulkUpload,
  addLeadEntityConsumptionHeadersByLeadId,
  updateLeadEntityAnnualConsumptionByLeadId,
  getLeadEntityAnnualConsumptionByLeadId,
  getEntityConsumptionHeaderByLeadId,
  addLeadExternally,
  stateDropdown,
  validateEntityInfo,
  addLeadLoeFile,
  deleteEntity,
  getLeadLoeFiles,
  addLeadLog,
  updateLeadCustomer,
  updateSelectedLoe,
  truncateLeadEntityLog,
  getLeadBulkEntityList,
  importLeadBulkEntityData,
  getCategoryDropdownById,
  validateBulkLeadEntityInfo,
  processLeadBulkEntity,
};
